import React from 'react';
import {Col} from '@deere/ux.uxframe-react';

export const BundleInfoField = ({label, value })=>(
    <Col>
        <dl className="uxf-dl uxf-dl-vertical mb-0">
            <dt>{label}</dt>
            <dd data-sl="mask">{value}</dd>
        </dl>
    </Col>
);

export default BundleInfoField;
